import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
	width: 100%;
	position: relative;

	[class$='container'] {
		width: 100%;
		font-size: 0.9em;

		[class$='control'] {
			width: 100%;
			height: 3.5em;
			border: 0.1em solid white;
			padding: 0 1em;
			color: ${vars.colorText};
			border-radius: 0.5em;
			font-size: 1em;

			[class$='placeholder'] {
				color: ${vars.colorTextLight};
			}
		}

		[class$='menu'] {
			z-index: 99;
		}
	}

	.error-message {
		display: inline-block;
		position: relative;
		left: 0;
		bottom: unset;
		color: tomato;
		font-size: 0.8em;
	}

	&.style-primary {
		[class$='container'] {
			width: 100%;

			[class$='control'] {
				background: white;
				box-shadow: none;

				[class$='ValueContainer'] {
					[class$='singleValue'] {
						color: #3b3c43;
					}
				}

				[class$='singleValue'] {
					color: #3b3c43;
				}

				[class$='IndicatorsContainer'] {
					[class$='indicatorSeparator'] {
						background-color: white;
					}
				}

				[class$='placeholder'] {
					color: ${vars.colorTextLight};
				}
			}

			// TEMP SELECT FIX ---------- START
			div:nth-of-type(2) {
				& > div {
					&[class$='indicatorContainer'] {
						cursor: pointer;

						> svg {
							width: 12px;
							transform: scale(1.2);
						}

						@media (pointer: fine) {
							&:hover {
								color: black;
							}
						}
					}
				}
			}
			// TEMP SELECT FIX ---------- END

			[class$='menu'] {
				z-index: 99;
				background-color: rgba(255, 255, 255, 1);
				border-radius: 0.5em;
				overflow: hidden;
				box-shadow: 0 1em 1em #484a521a;
				border: 1px solid #dedede;

				div {
					background: white;
					border-radius: 0.5em;

					[class$='option'] {
						background-color: white;
						color: #333333;
						border: none;
						cursor: pointer;

						&:hover {
							color: white;
							font-weight: 700;
							background-color: rgb(186, 148, 73);
						}
					}
				}
			}
		}

		&.disabled {
			[class$='container'] {
				[class$='control'] {
					opacity: 0.5;
					background-color: transparent;
				}
			}
		}
	}

	&.style-secondary {
		[class$='container'] {
			width: 100%;

			[class$='control'] {
				background: transparent;
				border: 0.01em solid #f1f1f1;
				box-shadow: none;

				[class$='ValueContainer'] {
					[class$='singleValue'] {
						color: white;
					}
				}

				[class$='singleValue'] {
					color: white;
				}

				[class$='IndicatorsContainer'] {
					[class$='indicatorSeparator'] {
						background-color: white;
					}

					[class$='indicatorContainer'] {
						color: white;
					}
				}

				[class$='placeholder'] {
					color: white;
				}
			}

			[class$='menu'] {
				z-index: 99;
				background-color: rgba(255, 255, 255, 0.2);

				div:nth-of-type(1) {
					[class$='option'] {
						color: white;
					}
				}
			}
		}

		&.disabled {
			[class$='container'] {
				[class$='control'] {
					background-color: #d7e2e4;
				}
			}
		}
	}

	&.style-cart {
		[class$='container'] {
			width: 100%;
			color: ${vars.colorWhite};

			[class$='control'] {
				background: transparent;
				border: 2px solid white;
				box-shadow: none;
				color: ${vars.colorWhite};
				border-radius: 5px;

				input {
					color: ${vars.colorWhite} !important;
					font-size: 16px !important;

					&::placeholder {
						font-size: 16px !important;
					}
				}

				[class$='ValueContainer'] {
					[class$='singleValue'] {
						color: ${vars.colorWhite};
					}
				}

				[class$='singleValue'] {
					color: ${vars.colorWhite};
				}

				[class$='indicatorSeparator'] {
					display: none;
				}

				[class$='indicatorContainer'] {
					position: relative;
					cursor: pointer;
					color: ${vars.colorWhite};
					margin-right: 3px;

					svg {
						color: ${vars.colorWhite};
					}

					&::before {
						top: 50%;
						left: 52%;
						transform: translate(-50%, -50%);
						position: absolute;
						content: '';
						height: 22px;
						width: 22px;
						border: 2px solid ${vars.colorWhite};
						border-radius: 5px;
					}
				}
			}

			[class$='placeholder'] {
				color: ${vars.colorWhite};
			}

			[class$='menu'] {
				z-index: 99;

				div:nth-of-type(1) {
					[class$='option'] {
						color: ${vars.colorText};
					}
				}
			}

			[class$='Input'] {
				color: ${vars.colorWhite};
			}
		}

		&.disabled {
			[class$='container'] {
				[class$='control'] {
					opacity: 0.5;
				}
			}
		}
	}

	&.decorator-left {
		[class$='container'] {
			[class$='control'] {
				padding-left: 2em;
			}
		}
	}

	&.decorator-right {
		[class$='container'] {
			[class$='control'] {
				padding-right: 2em;
			}
		}
	}

	@media all and (max-width: ${vars.mobileL}) {
		[class$='container'] {
			font-size: 16px !important;
			[class$='control'] {
				font-size: 1em;
				[class$='placeholder'] {
					font-size: 1em;
				}
			}
		}
	}

	@media all and (max-width: ${vars.mobileM}) {
		[class$='container'] {
			max-width: 115% !important;
		}
	}
`;
